// extracted by mini-css-extract-plugin
module.exports = {"instrumentFormWrapper":"InstrumentDetails_instrumentFormWrapper__2JJIw","titleBtn":"InstrumentDetails_titleBtn__1PddL","tabContent":"InstrumentDetails_tabContent__2auAJ"};